module.exports = __webpack_public_path__ + "static/media/thumbnail.2f85c3f0.jpg";